import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { CELLYTICS_DEFAULT_ANALYSIS_PATH } from '../cellytics-analysis';

const ACCESS_SESSION_KEY = "cellytics.access";
const ACCESS_SESSION_VALUE = "granted";
const ACCESS_USER = {
    id: "cellytics-access",
    email: "",
    name: "Cellytics NK",
    role: "admin",
};

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        if (this.hasAccess()) return location.href = CELLYTICS_DEFAULT_ANALYSIS_PATH;
    }

    private hasAccess() {
        return this.service.auth.check() || window.sessionStorage.getItem(ACCESS_SESSION_KEY) === ACCESS_SESSION_VALUE;
    }

    private grantAccess(session: any = ACCESS_USER) {
        window.sessionStorage.setItem(ACCESS_SESSION_KEY, ACCESS_SESSION_VALUE);
        this.service.auth.status = true;
        this.service.auth.session = session || ACCESS_USER;
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let access = JSON.parse(JSON.stringify(this.data));
        if (!access.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", access);

        if (code == 200) {
            this.grantAccess(data.session);
            location.href = CELLYTICS_DEFAULT_ANALYSIS_PATH;
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;